/**
 * 画布中绘制矩形
 * 参数: cav-画布对象  list-矩形数组 i-选中矩形下标
 **/
let drawdata = {}
let style = {}
// const direction = 0
export function openDraw (cav, list, data, styleList) {
  drawdata = data
  style = styleList
  // console.log('新繪製', drawdata)
  if (drawdata.drawFlag) {
    // console.log('新繪製')
    draw(cav, list)
  } else {
    // console.log('關閉繪製')
    // console.log(list)
    // // 画布初始化
    onlyShowandHover(cav, list)
  }
}
/* 操作执行方法分发 */
export function draw (cav, list, i) {
  // 画布初始化
  const ctx = cav.getContext('2d')
  ctx.strokeStyle = drawdata.color || 'blue'
  ctx.lineWidth = 2
  // 变量初始化
  let sX = 0 // 鼠标X坐标
  let sY = 0 // 鼠标Y坐标

  /*
      *鼠标移动进行第一层判断, 区分情况: 无矩形, 已有矩形无选中, 已有选中矩形
      */
  cav.onmousemove = function (em) {
    sX = em.offsetX
    sY = em.offsetY
    let iem // 鼠标移动时临时存储当前鼠标所在矩形的下标

    if (list.length === 0) { // **** 无矩形 ****
      reDraw(cav, ctx, list, iem)
      // 绘制新矩形
      newDraw(cav, ctx, list)
    } else if (i === undefined) { // **** 已有矩形无选中 ****
      // 判断鼠标位置
      list.forEach(function (value, index, array) {
        if (value.type === 'brush') {
          console.log('brush')
          judgePointsPosition(cav, ctx,value,sX,sY)
        } else {
          if (value.w > 0 && value.h > 0 && sX > value.x && sX < value.x + value.w && sY > value.y && sY < value.y + value.h) {
            // 鼠标在右下方向生成的矩形中
            iem = index
            setText(cav, ctx, list, iem)
            judgeDraw(cav, ctx, list, iem)
          }
          if (value.w < 0 && value.h > 0 && sX < value.x && sX > value.x + value.w && sY > value.y && sY < value.y + value.h) {
            // 鼠标在左下方向生成的矩形中
            iem = index
            setText(cav, ctx, list, iem)
            judgeDraw(cav, ctx, list, iem)
          }
          if (value.w > 0 && value.h < 0 && sX > value.x && sX < value.x + value.w && sY < value.y && sY > value.y + value.h) {
            // 鼠标在右上方向生成的矩形中
            iem = index
            setText(cav, ctx, list, iem)
            judgeDraw(cav, ctx, list, iem)
          }
          if (value.w < 0 && value.h < 0 && sX < value.x && sX > value.x + value.w && sY < value.y && sY > value.y + value.h) {
            // 鼠标在左上方向生成的矩形中
            iem = index
            setText(cav, ctx, list, iem)
            judgeDraw(cav, ctx, list, iem)
          }
          if (iem === undefined) {
            // 鼠标不在矩形中
            // if (drawdata.drawFlag) {
            reDraw(cav, ctx, list, iem)
            newDraw(cav, ctx, list)
            // }
          }
        }
      })
    } else { // **** 已有选中矩形 ****
      // 判断鼠标位置
      for (let index = 0; index < list.length; index++) {
        const value = list[index]
        if (value.type === 'brush') {
          console.log('brush')
        } else {
          if (sX < value.x + 5 && sX > value.x - 5 && sY < value.y + 5 && sY > value.y - 5) {
            // ***  鼠标在起点角  ***
            if (index === i) {
              changeDraw(cav, ctx, list, i, 1)
              break
            }
          } else if (sX < value.x + value.w + 5 && sX > value.x + value.w - 5 && sY < value.y + 5 && sY > value.y - 5) {
            // ***  鼠标在起点横向角  ***
            if (index === i) {
              changeDraw(cav, ctx, list, i, 2)
              break
            }
          } else if (sX < value.x + 5 && sX > value.x - 5 && sY < value.y + value.h + 5 && sY > value.y + value.h - 5) {
            // ***  鼠标在起点纵向角  ***
            if (index === i) {
              changeDraw(cav, ctx, list, i, 3)
              break
            }
          } else if (sX < value.x + value.w + 5 && sX > value.x + value.w - 5 && sY < value.y + value.h + 5 && sY > value.y + value.h - 5) {
            // ***  鼠标在终点角  ***
            if (index === i) {
              changeDraw(cav, ctx, list, i, 4)
              break
            }
          } else if (value.w > 0 && value.h > 0 && sX > value.x && sX < value.x + value.w && sY > value.y && sY < value.y + value.h) {
            // ***  鼠标在右下方向生成的矩形中  ***
            iem = index
            judgeDraw(cav, ctx, list, index)
            break
          } else if (value.w < 0 && value.h > 0 && sX < value.x && sX > value.x + value.w && sY > value.y && sY < value.y + value.h) {
            // ***  鼠标在左下方向生成的矩形中  ***
            iem = index
            judgeDraw(cav, ctx, list, index)
            break
          } else if (value.w > 0 && value.h < 0 && sX > value.x && sX < value.x + value.w && sY < value.y && sY > value.y + value.h) {
            // ***  鼠标在右上方向生成的矩形中  ***
            iem = index
            judgeDraw(cav, ctx, list, index)
            break
          } else if (value.w < 0 && value.h < 0 && sX < value.x && sX > value.x + value.w && sY < value.y && sY > value.y + value.h) {
            // ***  鼠标在左上方向生成的矩形中  ***
            iem = index
            judgeDraw(cav, ctx, list, index)
            break
          } else {
            if (iem === undefined) {
              // *** 鼠标不在矩形中 ***
              // if (drawdata.drawFlag) {
              newDraw(cav, ctx, list)
              // }
            }
          }
        }
      }
    }

    /* 鼠标移出画布区域时保存选中矩形下标(如有) */
    cav.onmouseout = function (eo) {
      if (i !== undefined) {
        // 初始化
        draw(cav, list, i)
      }
    }
  }
};

/* 编辑矩形四个角 */
function changeDraw (cav, ctx, list, i, site) {
  // cav.style.cursor = 'ne-resize'

  // site: 操作矩形角的位置, 1-起点 2-起点横向 3-起点纵向 4-终点
  const mark = list[i]

  /* 按下鼠标左键 */
  cav.onmousedown = function (ed) {
    // 保存鼠标落下位置的X, Y坐标, firefox中鼠标移动后ed.offsetX ed.offsetY会变成 0, 需要使用临时参数存储起来
    const sX = ed.offsetX // 起点X坐标
    const sY = ed.offsetY // 起点Y坐标
    let iframe = {}
    /* 移动鼠标 */
    cav.onmousemove = function (em) {
      // 计算绘制数据

      switch (site) {
        case 1:
          cav.style.cursor = 'nw-resize'
          iframe = {
            uuid: mark.uuid, /// 随机id，用于对比上一步下一步的回退操作
            x: em.offsetX,
            y: em.offsetY,
            w: mark.w - (em.offsetX - sX),
            h: mark.h - (em.offsetY - sY),
            color: mark.color,
            text: mark.text,
            id: mark.id,
            doctor: mark.doctor,
            originWidth: style.width,
            originHeight: style.height,
            direction: mark.direction || 0
          }
          break
        case 2:
          cav.style.cursor = 'ne-resize'
          iframe = {
            uuid: mark.uuid, /// 随机id，用于对比上一步下一步的回退操作
            x: mark.x,
            y: mark.y + (em.offsetY - sY),
            w: mark.w + (em.offsetX - sX),
            h: mark.h - (em.offsetY - sY),
            color: mark.color,
            text: mark.text,
            id: mark.id,
            doctor: mark.doctor,
            originWidth: style.width,
            originHeight: style.height,
            direction: mark.direction || 0
          }
          break
        case 3:
          cav.style.cursor = 'ne-resize'
          iframe = {
            uuid: mark.uuid,
            x: mark.x + (em.offsetX - sX),
            y: mark.y,
            w: mark.w - (em.offsetX - sX),
            h: mark.h + (em.offsetY - sY),
            color: mark.color,
            text: mark.text,
            id: mark.id,
            doctor: mark.doctor,
            originWidth: style.width,
            originHeight: style.height,
            direction: mark.direction || 0
          }
          break
        case 4:
          cav.style.cursor = 'nw-resize'
          iframe = {
            uuid: mark.uuid,
            x: mark.x,
            y: mark.y,
            w: mark.w + (em.offsetX - sX),
            h: mark.h + (em.offsetY - sY),
            color: mark.color,
            text: mark.text,
            id: mark.id,
            doctor: mark.doctor,
            originWidth: style.width,
            originHeight: style.height,
            direction: mark.direction || 0
          }
          break
      }
      // console.log('iframechange', iframe)
      window.changeDataFundus('change', iframe, i)
      list.splice(i, 1, iframe)
      // 重新绘制
      reDraw(cav, ctx, list, i)
    }

    /* 鼠标离开矩形区 */
    cav.onmouseout = function (eo) {
      //  console.log('change draw')

      // 重新绘制
      reDraw(cav, ctx, list)
      // 初始化
      draw(cav, list)
    }

    /* 监听键盘, 点击后可以控制删除, 由于移动矩形事件已经监听了onmousemove, 所以在移动矩形方法中仍有一次调用 */
    delDraw(cav, ctx, list, i)
  }
};

/* 绘制新矩形 */
function newDraw (cav, ctx, list) {
  cav.style.cursor = 'crosshair'
  // 初始化变量
  let start = false // 画框状态, false时不执行画框操作
  let sX = 0 // 起点X坐标
  let sY = 0 // 起点Y坐标

  /* 按下鼠标左键 */
  cav.onmousedown = function (ed) {
    /* 使用变量 */
    start = true
    sX = ed.offsetX
    sY = ed.offsetY
    window.changeDataFundus('openvisible', undefined, undefined)
    /* 重置按键监听, 防止选中取消后仍可删除 */
    delDraw(cav, ctx, list, null)

    /* 鼠标移动 */
    cav.onmousemove = function (em) {
      if (start) {
        // 重新绘制
        reDraw(cav, ctx, list)
        // 设置边框为虚线
        ctx.beginPath()
        ctx.setLineDash([8, 4])
        ctx.rect(sX, sY, em.offsetX - sX, em.offsetY - sY)
        ctx.stroke()
      }
    }

    /* 鼠标抬起 */
    cav.onmouseup = function (eu) {
      /// 从左右下画，左右上，右左下,右左上，
      if (start && Math.abs(eu.offsetX - sX) > 10 && Math.abs(eu.offsetY - sY) > 10) {
        let direction = 0
        if ((eu.offsetX - sX) > 0 && (eu.offsetY - sY) > 10) { // 左右下
          direction = 0
        } else if ((eu.offsetX - sX) > 0 && (eu.offsetY - sY) < 10) { // 左右上
          direction = 1
        } else if ((eu.offsetX - sX) < 0 && (eu.offsetY - sY) > 10) { // 右左下
          direction = 2
        } else if ((eu.offsetX - sX) < 0 && (eu.offsetY - sY) < 10) { // 右左上
          direction = 3
        }
        // 改变矩形数组
        const frame = {
          uuid: Number(new Date().getTime()), /// 新画的框就随机id，用于对比上一步下一步的回退操作
          x: sX,
          y: sY,
          w: eu.offsetX - sX,
          h: eu.offsetY - sY,
          color: drawdata.color,
          text: drawdata.text,
          id: drawdata.id,
          doctor: drawdata.doctor,
          originWidth: style.width,
          originHeight: style.height,
          direction: direction || 0
        }

        window.changeDataFundus('push', frame, undefined)
        list.push(frame)
        // 重新绘制
        reDraw(cav, ctx, list, list.length - 1)
        // 改变画框状态
        start = false
        // 初始化
        draw(cav, list)
      } else {
        // 重新绘制
        reDraw(cav, ctx, list)
        // 改变画框状态
        start = false
        // 初始化
        draw(cav, list)
      }
    }

    /* 鼠标离开矩形区 */
    cav.onmouseout = function (eo) {
      if (start && Math.abs(eo.offsetX - sX) > 10 && Math.abs(eo.offsetY - sY) > 10) {
        let direction = 0
        if ((eo.offsetX - sX) > 0 && (eo.offsetY - sY) > 10) { // 左右下
          direction = 0
        } else if ((eo.offsetX - sX) > 0 && (eo.offsetY - sY) < 10) { // 左右上
          direction = 1
        } else if ((eo.offsetX - sX) < 0 && (eo.offsetY - sY) > 10) { // 右左下
          direction = 2
        } else if ((eo.offsetX - sX) < 0 && (eo.offsetY - sY) < 10) { // 右左上
          direction = 3
        }
        // 改变矩形数组
        const frame = {
          uuid: Number(new Date().getTime()), /// 随机id，用于对比上一步下一步的回退操作
          x: sX,
          y: sY,
          w: eo.offsetX - sX,
          h: eo.offsetY - sY,
          color: drawdata.color,
          text: drawdata.text,
          id: drawdata.id,
          doctor: drawdata.doctor,
          originWidth: style.width,
          originHeight: style.height,
          direction: direction
        }

        window.changeDataFundus('push', frame, undefined)
        list.push(frame)
        // 重新绘制
        reDraw(cav, ctx, list, list.length - 1)
        // 改变画框状态
        start = false
        // 初始化
        draw(cav, list)
      } else {
        // 重新绘制
        reDraw(cav, ctx, list)
        // 改变画框状态
        start = false
        // 初始化
        draw(cav, list)
      }
    }
  }
};

/* 选中矩形, 重绘矩形, 并分发后续事件 */
function judgeDraw (cav, ctx, list, iem) {
  cav.style.cursor = 'default'
  // 初始化变量
  let sX = 0 // 起点X坐标
  let sY = 0 // 起点Y坐标

  // 初始化
  //  draw(cav, list, iem)
  /* 按下鼠标左键 */
  cav.onmousedown = function (ed) {
    console.log('iem', iem)
    sX = ed.offsetX
    sY = ed.offsetY
    // 更改选中状态, 重绘矩形
    reDraw(cav, ctx, list, iem)

    /* 当仅点击选中矩形便抬起鼠标后, 重新初始化画布 */
    cav.onmouseup = function () {
      // window.changeDataFundus('openvisible', undefined, undefined)
      // 重绘矩形
      reDraw(cav, ctx, list, iem)

      // 初始化
      draw(cav, list, iem)
    }

    /* 按住拖动鼠标, 移动选中矩形 */
    moveDraw(cav, ctx, list, iem, sX, sY)

    /* 监听键盘, 点击后可以控制删除, 由于移动矩形事件已经监听了onmousemove, 所以在移动矩形方法中仍有一次调用 */
    delDraw(cav, ctx, list, iem)

    window.changeDataFundus('openvisible', list[iem], iem)
  }
};

/* 移动矩形 */
function moveDraw (cav, ctx, list, i, sX, sY) {
  const mark = list[i]
  cav.onmousemove = function (em) {
    const iframe = {
      uuid: mark.uuid,
      x: mark.x + (em.offsetX - sX),
      y: mark.y + (em.offsetY - sY),
      w: mark.w,
      h: mark.h,
      color: mark.color,
      text: mark.text,
      id: mark.id,
      doctor: mark.doctor,
      originWidth: style.width,
      originHeight: style.height,
      direction: mark.direction || 0
    }
    //  console.log('iframemove', iframe)

    window.changeDataFundus('change', iframe, i)
    list.splice(i, 1, iframe)
    /* 监听键盘, 使矩形在移动后仍可删除, 在点击未移动过的矩形时仍有一次监听 */
    delDraw(cav, ctx, list, i)
    // 重新绘制
    reDraw(cav, ctx, list, i)
  }

  cav.onmouseup = function () {
    // 重绘矩形
    reDraw(cav, ctx, list, i)

    // 初始化
    draw(cav, list, i)
  }
};

/* 删除矩形 */
function delDraw (cav, ctx, list, i) {
  /* 按键事件 */
  if (i === null) {
    // i为null时阻止按键监听事件冒泡
    window.onkeydown = function (k) {
      return false
    }
    // window.removeEventListener('keydown', keyfun2, true)
  } else {
    // 监听按键事件
    window.onkeydown = function (k) {
      const key = k.key || k.which
      if (key === 'Delete' && i !== null) {
        if (list.length >= 1) {
          // 删除数组元素

          window.changeDataFundus('delete', undefined, i)
          list.splice(i, 1)
          // 重绘矩形
          reDraw(cav, ctx, list)
        } else {
          /* 矩形数组长度为0, 已将矩形框全部删除 */
          ctx.clearRect(0, 0, cav.width, cav.height)
        }
        // 重置监听状态, 防止删除完毕后, 按键监听不消失
        delDraw(cav, ctx, list, null)
        // 重绘矩形
        reDraw(cav, ctx, list)
        // 初始化
        draw(cav, list)
      }
    }
    // window.addEventListener('keydown', keyfun2(), true)
  }
};
/* 重绘所有矩形 */
export function reDraw (cav, ctx, list, i) {
  ctx.setLineDash([8, 0]) // 设置边框为实线
  ctx.clearRect(0, 0, cav.width, cav.height)
 
  // 绘制未选中部分
  list.forEach(function (value, index, array) {
    if (value.type && value.type === 'brush') {
      // console.log('brush')
      reDrawPoints(cav, ctx,value)
    } else {
      // console.log('dff')
      if (i === undefined) {
        // window.changeDataFundus('openvisible', undefined, undefined)
      }
      if (i === undefined || index !== i) {
        ctx.beginPath()
        ctx.strokeStyle = value.color
        ctx.rect(value.x, value.y, value.w, value.h)
        ctx.stroke()
      }
    }
  })
  // 绘制已选中部分
  list.forEach(function (value, index, array) {
    if (value.type === 'brush') {
      // console.log('brush')
      reDrawPoints(cav, ctx,value)
    } else {
      if (index === i) {
        // console.log('i', i)
        /* 绘制方框 */
        ctx.beginPath()
        ctx.strokeStyle = '#ccc'
        ctx.rect(value.x, value.y, value.w, value.h)
        ctx.fillStyle = 'RGBA(102,102,102,0.2)'
        ctx.fillRect(value.x, value.y, value.w, value.h)
        ctx.stroke()
        // 绘制四个角的圆圈
        ctx.beginPath()
        ctx.strokeStyle = '#ccc'
        ctx.arc(value.x, value.y, 5, 0, Math.PI * 2)
        ctx.fillStyle = '#ccc'
        ctx.fill()// 画起点实心圆
        ctx.stroke()
        ctx.beginPath()
        ctx.arc(value.x, value.y + value.h, 5, 0, Math.PI * 2)
        ctx.fillStyle = '#ccc'
        ctx.fill()// 画起点纵向实心圆
        ctx.stroke()
        ctx.beginPath()
        ctx.arc(value.x + value.w, value.y + value.h, 5, 0, Math.PI * 2)
        ctx.fillStyle = '#ccc'
        ctx.fill()// 画起点横向实心圆
        ctx.stroke()
        ctx.beginPath()
        ctx.arc(value.x + value.w, value.y, 5, 0, Math.PI * 2)
        ctx.fillStyle = '#ccc'
        ctx.fill()// 画终点实心圆
        ctx.stroke()
        window.changeDataFundus('openvisible', value, index)
      }
    }
  })
  
  // window.changeDataFundus('reDrewbrush')
  
}

/// 绘制框上方文字
function setText (cav, ctx, list, iem) {
  // 左右下画0，左右上1，右左下2,右左上3，
  const value = list[iem]

  if (value.direction === 1) { // 左右上
    ctx.textAlign = 'left'
    ctx.fillStyle = list[iem].color
    ctx.fillRect(list[iem].x, value.y + value.h - 20, ctx.measureText(`${list[iem].text}(${list[iem].doctor})`).width + 10, 20)
    ctx.font = '14px "微软雅黑"'
    ctx.fillStyle = list[iem].id === 2 || list[iem].id === 3 || list[iem].id === 6 || list[iem].id === 7 ? '#fff' : '#000'
    ctx.fillText(`${list[iem].text}(${list[iem].doctor})`, value.x + 5, value.y + value.h - 5)
  } else if (value.direction === 2) { // 右左下
    ctx.textAlign = 'left'
    ctx.fillStyle = list[iem].color
    ctx.fillRect(value.x + value.w, value.y - 20, ctx.measureText(`${list[iem].text}(${list[iem].doctor})`).width + 10, 20)
    ctx.font = '14px "微软雅黑"'
    ctx.fillStyle = list[iem].id === 2 || list[iem].id === 3 || list[iem].id === 6 || list[iem].id === 7 ? '#fff' : '#000'
    ctx.fillText(`${list[iem].text}(${list[iem].doctor})`, value.x + value.w + 5, value.y - 5)
  } else if (value.direction === 3) { // 右左上
    ctx.textAlign = 'left'
    ctx.fillStyle = list[iem].color
    ctx.fillRect(value.x + value.w, value.y + value.h - 20, ctx.measureText(`${list[iem].text}(${list[iem].doctor})`).width + 10, 20)
    ctx.font = '14px "微软雅黑"'
    ctx.fillStyle = list[iem].id === 2 || list[iem].id === 3 || list[iem].id === 6 || list[iem].id === 7 ? '#fff' : '#000'
    ctx.fillText(`${list[iem].text}(${list[iem].doctor})`, value.x + value.w + 5, value.y + value.h - 5)
  } else {
    ctx.textAlign = 'left'
    ctx.fillStyle = list[iem].color
    ctx.fillRect(list[iem].x, list[iem].y - 20, ctx.measureText(`${list[iem].text}(${list[iem].doctor})`).width + 10, 20)
    ctx.font = '14px "微软雅黑"'
    ctx.fillStyle = list[iem].id === 2 || list[iem].id === 3 || list[iem].id === 6 || list[iem].id === 7 ? '#fff' : '#000'
    ctx.fillText(`${list[iem].text}(${list[iem].doctor})`, list[iem].x + 5, list[iem].y - 5)
  }
}

/// /关闭绘制的情况下，只画出框，并且显示hover
function onlyShowandHover (cav, list, i) {
  
  // 画布初始化
  const ctx = cav.getContext('2d')
  ctx.strokeStyle = drawdata.color || 'blue'
  ctx.lineWidth = 2
  // 变量初始化
  let sX = 0 // 鼠标X坐标
  let sY = 0 // 鼠标Y坐标
  reDraw(cav, ctx, list, i)
  /*
      *鼠标移动进行第一层判断, 区分情况: 无矩形, 已有矩形无选中, 已有选中矩形
      */
  cav.onmousemove = function (em) {
    sX = em.offsetX
    sY = em.offsetY
    let iem // 鼠标移动时临时存储当前鼠标所在矩形的下标
    // console.log("12222222222")
    if (list.length === 0) { // **** 无矩形 ****
      // reDraw(cav, ctx, list, iem)
    } else if (i === undefined) { // **** 已有矩形无选中 ****
      // 判断鼠标位置
      list.forEach(function (value, index, array) {

        if (value.type === 'brush') {
          // console.log('brush')
          judgePointsPosition(cav, ctx,value,sX,sY)
        } else {
          if (value.w > 0 && value.h > 0 && sX > value.x && sX < value.x + value.w && sY > value.y && sY < value.y + value.h) {
            // 鼠标在右下方向生成的矩形中
            iem = index
            setText(cav, ctx, list, iem)
            // judgeDraw(cav, ctx, list, iem)
          }
          if (value.w < 0 && value.h > 0 && sX < value.x && sX > value.x + value.w && sY > value.y && sY < value.y + value.h) {
            // 鼠标在左下方向生成的矩形中
            iem = index
            setText(cav, ctx, list, iem)
            // judgeDraw(cav, ctx, list, iem)
          }
          if (value.w > 0 && value.h < 0 && sX > value.x && sX < value.x + value.w && sY < value.y && sY > value.y + value.h) {
            // 鼠标在右上方向生成的矩形中
            iem = index
            setText(cav, ctx, list, iem)
            // judgeDraw(cav, ctx, list, iem)
          }
          if (value.w < 0 && value.h < 0 && sX < value.x && sX > value.x + value.w && sY < value.y && sY > value.y + value.h) {
            // 鼠标在左上方向生成的矩形中
            iem = index
            setText(cav, ctx, list, iem)
            // judgeDraw(cav, ctx, list, iem)
          }
          let da = {
            x: sX,
            y: sY
          }
          window.changeDataFundus('hoverbursh', em)
          if (iem === undefined) {
            // 鼠标不在矩形中
            // if (drawdata.drawFlag) {
            reDraw(cav, ctx, list, iem)
            // }
          }
        }
      })
    } else {

    }
    cav.style.cursor = 'auto'
    cav.onmouseout = null
    cav.onmousedown = null
    cav.onmouseup = null
  }
  
}


// 判断是否在坐标区域内最大最小x,最大最小y
function judgePointsPosition (cav,ctx,value,x, y) {
  // console.log(x, y)
  // for (let j = 0; j < dataPoints.length; j++) {
    /// 只判断大概范围
    const xMax = value.xMax
    const yMax = value.yMax
    // console.log(xMax, yMax)
    if (xMax && yMax) {
      if (xMax.y < yMax.y) {
        if (x > (xMax.x - 40) && x < xMax.x) {
          if (y < (xMax.y + 30) && y > xMax.y-30) {
            hoverText(cav,ctx,value, x, y)
            // break
          }
        }
      } else if (xMax.y >= yMax.y) {
        if (x > (xMax.x - 40) && x < xMax.x) {
          if (y < (yMax.y - 30) && y > yMax.y+30) {
            hoverText(cav,ctx,value, x, y)
            // break
          }
        }
      } else {
        // this.reDrawPoints()
      }
    }
  // }
}

 // 显示hover提示
 function hoverText (cav,ctx,value, x, y) {
  ctx.fillStyle = value.color
  ctx.fillRect(x, y - 5, ctx.measureText(`${value.text}(${value.doctor})`).width + 10, 20)
  ctx.font = '14px "微软雅黑"'
  ctx.fillStyle = value.id === 2 || value.id === 3 || value.id === 6 || value.id === 7 ? '#fff' : '#000'
   ctx.fillText(`${value.text}(${value.doctor})`, x + 5, y + 10)
   console.log('显示hover提示')
}

/// 重绘不规则图形
function  reDrawPoints (cav,ctx,value) {
  ctx.fillStyle = value.color
  value.points.forEach(point => {
    ctx.fillRect(point.x, point.y, 1, 1) // 绘制一个2x2像素的点
  })
}